import { useSuspenseQuery } from '@tanstack/react-query'

import { GetUltimosAtendimentosService } from '@/features/atendimento/services'
import { atendimentoKeys } from '@/features/atendimento/utils/queries'

export const useSuspenseUltimosAtendimentos = () => {
  return useSuspenseQuery({
    queryKey: atendimentoKeys.ultimosAtendimentos(),
    queryFn: async () => new GetUltimosAtendimentosService().execute(),
    staleTime: 1000 * 60 * 10,
  })
}
